/* CSS owns the linear motion. JS only fills and measures identical halves. */
(() => {
  const ticker = document.querySelector('.ticker');
  if (!ticker) return;
  const track = ticker.querySelector('.ticker-track');
  const first = ticker.querySelector('.ticker-group');
  const unit = ticker.querySelector('.ticker-unit');
  const button = ticker.querySelector('.ticker-playback');
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const speed = 42; // CSS pixels / second, independent of viewport and repeat count.
  let distance = 0, previousUnit = 0, repeats = 0, paused = false;
  const playback = () => {
    ticker.dataset.paused = String(paused || document.hidden || motion.matches);
    button.hidden = motion.matches;
    button.setAttribute('aria-label', paused ? 'Reproducir la tira de palabras' : 'Pausar la tira de palabras');
    button.setAttribute('aria-pressed', String(paused));
  };
  const layout = () => {
    if (motion.matches) { playback(); return; }
    // Computed layout width is fractional and unaffected by the strip's rotation.
    const width = parseFloat(getComputedStyle(unit).width);
    if (!(width > 0)) return;
    const count = Math.max(1, Math.ceil(ticker.clientWidth / width));
    if (width === previousUnit && count === repeats) { playback(); return; }
    const animation = track.getAnimations?.()[0];
    const elapsed = Number(animation?.currentTime) || 0;
    // Retain the same position within one repeated phrase on resize/font swap.
    const offset = previousUnit ? (elapsed * speed / 1000) % previousUnit : 0;
    const phase = previousUnit ? offset / previousUnit : 0;
    first.replaceChildren(unit);
    for (let i = 1; i < count; i++) first.append(unit.cloneNode(true));
    track.replaceChildren(first, first.cloneNode(true));
    distance = width * count;
    previousUnit = width;
    repeats = count;
    track.style.setProperty('--ticker-duration', `${distance / speed}s`);
    ticker.dataset.ready = 'true';
    const updated = track.getAnimations?.()[0];
    if (updated) updated.currentTime = phase * width / speed * 1000;
    playback();
  };
  button.addEventListener('click', () => { paused = !paused; playback(); });
  document.addEventListener('visibilitychange', playback);
  motion.addEventListener('change', layout);
  window.addEventListener('resize', layout, { passive: true });
  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(layout);
    observer.observe(ticker);
    observer.observe(unit);
  }
  layout();
  document.fonts?.ready.then(layout);
  document.fonts?.addEventListener('loadingdone', layout);
})();
